var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_297_214",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 19
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0131836,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_297_214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 16.5132C7.9625 16.5132 6.9875 16.3163 6.075 15.9226C5.1625 15.5288 4.36875 14.9944 3.69375 14.3194C3.01875 13.6444 2.48438 12.8507 2.09063 11.9382C1.69687 11.0257 1.5 10.0507 1.5 9.01318C1.5 7.97568 1.69687 7.00068 2.09063 6.08818C2.48438 5.17568 3.01875 4.38193 3.69375 3.70693C4.36875 3.03193 5.1625 2.49756 6.075 2.10381C6.9875 1.71006 7.9625 1.51318 9 1.51318C9.8125 1.51318 10.5813 1.63193 11.3062 1.86943C12.0312 2.10693 12.7 2.43818 13.3125 2.86318L12.225 3.96943C11.75 3.66943 11.2438 3.43506 10.7063 3.26631C10.1688 3.09756 9.6 3.01318 9 3.01318C7.3375 3.01318 5.92188 3.59756 4.75313 4.76631C3.58438 5.93506 3 7.35068 3 9.01318C3 10.6757 3.58438 12.0913 4.75313 13.2601C5.92188 14.4288 7.3375 15.0132 9 15.0132C10.6625 15.0132 12.0781 14.4288 13.2469 13.2601C14.4156 12.0913 15 10.6757 15 9.01318C15 8.78818 14.9875 8.56318 14.9625 8.33818C14.9375 8.11318 14.9 7.89443 14.85 7.68193L16.0688 6.46318C16.2063 6.86318 16.3125 7.27568 16.3875 7.70068C16.4625 8.12568 16.5 8.56318 16.5 9.01318C16.5 10.0507 16.3031 11.0257 15.9094 11.9382C15.5156 12.8507 14.9813 13.6444 14.3063 14.3194C13.6313 14.9944 12.8375 15.5288 11.925 15.9226C11.0125 16.3163 10.0375 16.5132 9 16.5132ZM7.95 12.4632L4.7625 9.27568L5.8125 8.22568L7.95 10.3632L15.45 2.84443L16.5 3.89443L7.95 12.4632Z",
    fill: "#6CFF95"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.7b74b5f4892ac0a07b4ae22bde5fa66d.svg";
export { ForwardRef as ReactComponent };